module.exports = __webpack_public_path__ + "img/40.a5fb5b37.png";